module.exports = __webpack_public_path__ + "static/media/Footprints-Logo.fdf67f6b.svg";